import BuildConfig from './BuildConfig';

export default BuildConfig;
